import { render } from "./g-wizard-control.vue?vue&type=template&id=afc753a4&ts=true"
import script from "./g-wizard-control.vue?vue&type=script&lang=tsx"
export * from "./g-wizard-control.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__